import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { adminUrl, goTo, tenantUrl } from '../lib/host';
import { usePlanLabel } from '../lib/usePlans';
import '../components/Layout.css';
import AuthShell from '../components/AuthShell';
import './Auth.css';

export default function SelectOrganization() {
  const planLabel = usePlanLabel();
  const navigate = useNavigate();
  const { session, user, logout, canCreateOrg } = useAuth();
  const orgs = session.memberships.filter((m) => m.status === 'active');

  return (
    <AuthShell>
      <h2>Choose a company</h2>
      <p className="tcx-muted">Signed in as {user.email}</p>

      <div className="tcx-org-list">
        {orgs.length === 0 && <p className="tcx-muted">You aren't a member of any company yet.</p>}
        {orgs.map((m) => (
          <button
            key={m.slug}
            className="tcx-org-card"
            disabled={m.tenant_status !== 'active'}
            onClick={() => goTo(tenantUrl(m.slug))}
          >
            <span>
              {m.name}
              <small>{m.tenant_status === 'active' ? `${m.slug} · ${planLabel(m.plan)}` : 'Suspended'}</small>
            </span>
            <span className={`tcx-role tcx-role-${m.role}`}>{m.role}</span>
          </button>
        ))}
      </div>

      {canCreateOrg && (
        <Link to="/create-org" className="submit-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
          + Create company
        </Link>
      )}
      <p className="auth-link">
        {user.is_super_admin && <><a href={adminUrl()}>Super Admin panel</a> · </>}
        <button className="tcx-link-btn" onClick={async () => { await logout(); navigate('/login'); }}>Log out</button>
      </p>
    </AuthShell>
  );
}
